var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 36.33000183105469,
    height: 26.229999542236328,
    viewBox: "0 0 36.33000183105469 26.229999542236328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 36.33000183105469,
    height: 26.229999542236328,
    rx: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_9_5990)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,1.2246468525851679e-16,-1.2246468525851679e-16,-1,72.66000366210938,25.219999313354485)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 36.33000183105469,
    y1: 12.109999656677246,
    x2: 71.95000076293945,
    y2: 12.109999656677246,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#FFFFFF",
    fill: "none",
    strokeWidth: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.416967978542328,13.110099994039535L13.823599978542328,0.7035529940395355L13.116399978542328,-0.0035530059604644837L0.00303197854232784,13.109899994039536L13.116299978542328,26.233399994039537L13.823699978542328,25.526599994039536L1.416967978542328,13.110099994039535Z",
    fillRule: "evenodd",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/leftIcon.8acf6b063f5c53c92e3459d0a5d45f43.svg";
export { ForwardRef as ReactComponent };